import { styled } from '../theme';

type Props = {
    stripes?: boolean;
};

const TableContainer = styled('div')(({ theme }) => ({
    width: '100%',
    maxWidth: '100%',
    overflowX: 'auto',
}));

const StyledTable = styled('table')<Props>(({ theme, stripes }) => ({
    width: '100%',
    tableLayout: 'auto',
    fontFamily: theme.typography.fontFamily.medium,
    color: theme.color.jetBlack,
    ...(stripes && {
        'tbody tr:nth-of-type(odd)': {
            background: theme.color.tableZebraStripeGray,
        },
    }),
}));

const Table = (props: Props & React.TableHTMLAttributes<HTMLTableElement>) => {
    return (
        <TableContainer>
            <StyledTable {...props} />
        </TableContainer>
    );
};

export default Table;
